import type * as Ably from 'ably'
import type { RegisterCfdType } from '@vend/types/register'

const ablyTokenKey = (type: RegisterCfdType, registerId: string) =>
  `ABLY_TOKEN:${type}:${registerId}`

const channelNameKey = (type: RegisterCfdType, registerId: string) =>
  `CHANNEL_NAME:${type}:${registerId}`

export const getAblyToken = (
  type: RegisterCfdType,
  registerId: string
): Ably.TokenDetails | null => {
  const raw = localStorage.getItem(ablyTokenKey(type, registerId))
  return raw ? (JSON.parse(raw) as Ably.TokenDetails) : null
}

export const setAblyToken = (
  type: RegisterCfdType,
  registerId: string,
  token: Ably.TokenDetails
): void => {
  localStorage.setItem(ablyTokenKey(type, registerId), JSON.stringify(token))
}

export const clearAblyToken = (
  type: RegisterCfdType,
  registerId: string
): void => {
  localStorage.removeItem(ablyTokenKey(type, registerId))
}

export const getChannelName = (
  type: RegisterCfdType,
  registerId: string
): string | null => localStorage.getItem(channelNameKey(type, registerId))

export const setChannelName = (
  type: RegisterCfdType,
  registerId: string,
  name: string
): void => {
  localStorage.setItem(channelNameKey(type, registerId), name)
}

export const clearChannelName = (
  type: RegisterCfdType,
  registerId: string
): void => {
  localStorage.removeItem(channelNameKey(type, registerId))
}
